export const GET_ALL_SURVEYS_LOADING = "GET_ALL_SURVEYS_LOADING";
export const GET_ALL_SURVEYS_SUCCESS = "GET_ALL_SURVEYS_SUCCESS";
export const GET_ALL_SURVEYS_FAILURE = "GET_ALL_SURVEYS_FAILURE";
